// extracted by mini-css-extract-plugin
export default {"addToCartControl":"L2-z","giftCard":"M2-z","btnContainer":"N2-z","cartButton":"O2-z","disabled":"P2-z","stockMessage":"Q2-z"};